import Splide from '@splidejs/splide';
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

$(function () {
  if( $('.splide.topMv-slide').length > 0 ) {
    const topMvSplide = new Splide(".splide.topMv-slide", {
      type: "fade",
      gap: 0,
      arrows: false,
      interval: 5000,
      pagination: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
      // prefers-reduced-motion有効時もautoplayを維持（RDP/VM等でアニメーション無効だと止まる対策）
      reducedMotion: {
        autoplay: true,
        speed: 400,
      },
    });

    topMvSplide.mount();
  }

  let sec09Slide;

  // リサイズ時の処理
  $(window).on('load resize', function() {
    if( $('.splide.sec09-slide').length > 0 ) {
      if( $(window).width() < 768 ) {
        if (!sec09Slide) {
          sec09Slide = new Splide(".splide.sec09-slide", {
            type: "loop",
            fixedWidth: "79%",
            arrows: true,
            pagination: false,
            gap: "10%",
            focus: "center",
          }).mount();
        }
      } else {
        if (sec09Slide) {
          sec09Slide.destroy();
          sec09Slide = null;
        }
      }
    }
  });
});
